import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import { TemplateService } from '../../../services/template.service';
import * as _ from 'lodash';

import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';

@Component({
  selector: 'app-download-request',
  templateUrl: './download-request.component.html',
  styleUrls: ['./download-request.component.scss'],
  providers: [TemplateService]
})
export class DownloadRequestComponent implements OnInit, OnDestroy {
  calendarLocale = CALENDAR_LOCALE.TH;
  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  minDate: Date;
  maxDate: Date;
  taxID = '';
  documentNumber = '';
  email = '';
  isSuccess = false;
  loading = false;
  error = {};
  requestType = 0;
  buyerName: string;
  documentType: any;
  allDocumentType = [];
  rdDocumentType: any;
  selectedRdDocumentType: any;

  private subs = new SubSink();

  constructor(
    private downloadService: DownloadService,
    private template: TemplateService) {}

  ngOnInit() {
    // this.loadInput();
    // this.loadDropdown();

    this.rdDocumentType = this.template.getDropdown();
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateTaxID(taxID) {
    if (taxID == null || taxID === '') {
      return true;
    }
    return this.taxID.length === 13;
  }

  validateInput() {
    this.validateEmail(this.email) === false
      ? (this.error['email'] = true)
      : delete this.error['email'];
    return this.error;
  }

  submit() {
    this.error = {};
    if (!isEmpty(this.validateInput())) {
      return;
    }

    const data = {
      rd_doc_type: this.selectedRdDocumentType,
      buyer_name: this.buyerName,
      document_number: this.documentNumber,
      document_type_id: _.isNil(this.documentType)
        ? this.documentType
        : _.uniq(this.allDocumentType),
      document_start_date: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '',
      document_end_date: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '',
      email: this.email
    };
    this.loading = true;
    this.downloadService.createDocumentRequest(data).subscribe(
      () => {
        this.isSuccess = true;
        this.loading = false;
      }
    );
  }

  reloadPage() {
    location.reload();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-request/download-request.component.ts